import Style from "./TeamSeatsPanel.module.less";
import FJLocalStore from "../../store/FJLocalStore";
import decreaseIcon from "../../icon/decrease.svg";
import addIcon from "../../icon/add.svg";
import InlineSVG from "react-inlinesvg";
import {useState} from "react";
import classNames from "classnames";
import {useSelector} from "react-redux";

const TeamSeatsPanel = ({ seatCount, onChangeSeats }) => {
    const [value, setValue] = useState('');
    const [isFocus, setIsFocus] = useState(false);
    const minSeatCount = useSelector((state) => state.mainReducer.minSeatCount);
    const maxSeatCount = useSelector((state) => state.mainReducer.maxSeatCount);

    if (!isFocus && value !== `${seatCount}`) {
        setValue(`${seatCount}`)
    }

    const _onChange = e => {
        if (e.target.value === '') {
            setValue('');
        } else if (e.target.validity.valid) {
            const length = Math.max(Math.min(Number(e.target.value), maxSeatCount), 1);
            setValue(`${length}`);
            onChangeSeats(length);
        }
    };

    const _onBlur = () => {
        setIsFocus(false);

        const length = Number(value);
        if (length < minSeatCount) {
            setValue(`${length}`);
            onChangeSeats(length);
        }
    }

    const _onFocus = () => {
        setIsFocus(true);
    }
    const canAdd = seatCount < maxSeatCount;
    const canDecrease = seatCount > minSeatCount;

    const _onAdd = () => {
        if (!canAdd) return;
        const newLength = seatCount+1;
        onChangeSeats(newLength);
    }

    const _onDecrease = () => {
        if (!canDecrease) return;
        const newLength = seatCount-1;
        onChangeSeats(newLength);
    }

    return <div className={Style.team_panel}>
        <div className={Style.title}>{FJLocalStore._("How many seats do you need?")}</div>
        <div className={Style.input}>
            <div className={classNames(Style.btn, {[Style.disabled]: !canDecrease})} onClick={_onDecrease}>
                <InlineSVG src={decreaseIcon} />
            </div>
            <input value={value} pattern='[0-9]*' type='text' onChange={_onChange} onBlur={_onBlur} onFocus={_onFocus} />
            <div className={classNames(Style.btn, {[Style.disabled]: !canAdd})} onClick={_onAdd}>
                <InlineSVG src={addIcon} />
            </div>
        </div>
    </div>
}

export default TeamSeatsPanel;